import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { CustomDatePicker } from '../../../../semantic-ui/components/custom-datepicker';
import { FormInputField } from '../../../../semantic-ui/components/form-input-field';
import { CustomLoader } from '../../../../components/custom-loader';

export const DateCargoCollectionModalFormView = ({ isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="date-cargo-collection-modal-form__wrapper">
			<Grid className="date-cargo-collection-modal-form">
				<Grid.Row className="date-cargo-collection-modal-form__row">
					<Grid.Column width={6} className="date-cargo-collection-modal-form__column">
						Дата
					</Grid.Column>
					<Grid.Column
						width={6}
						computer={6}
						tablet={5}
						mobile={8}
						className="date-cargo-collection-modal-form__column"
					>
						<Field
							name="fetch_at"
							type="text"
							component={CustomDatePicker}
							autoComplete="off"
							placeholder=". . / . . / . . . . "
							dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						/>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="date-cargo-collection-modal-form__row">
					<Grid.Column width={6} className="date-cargo-collection-modal-form__column">
						Время
					</Grid.Column>
					<Grid.Column
						width={6}
						computer={6}
						tablet={5}
						mobile={8}
						className="date-cargo-collection-modal-form__column"
					>
						<div className="date-cargo-collection-modal-form__column-field">
							<Field
								name="fetch_time_from"
								type="time"
								component={FormInputField}
								autoComplete="off"
								placeholder="Время забора от"
							/>
						</div>
						-
						<div className="date-cargo-collection-modal-form__column-field">
							<Field
								name="fetch_time_to"
								type="time"
								component={FormInputField}
								autoComplete="off"
								placeholder="Время забора до"
							/>
						</div>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</div>
	);
};

DateCargoCollectionModalFormView.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};
